import { render, staticRenderFns } from "./NewBlocklistRecordModal.vue?vue&type=template&id=5a49ec26&"
import script from "./NewBlocklistRecordModal.vue?vue&type=script&lang=js&"
export * from "./NewBlocklistRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports